import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { ApiResponse } from './api.service';

export interface MercadoPagoCheckoutResponse {
  order: any;
  preferenceId: string;
  initPoint?: string;
  sandboxInitPoint?: string;
}

@Injectable({ providedIn: 'root' })
export class CheckoutService {

  private readonly paymentsUrl = environment.paymentsUrl;
  private authService = inject(AuthService);

  constructor(private http: HttpClient) {}

  createCheckout(orderPayload: any): Observable<ApiResponse<MercadoPagoCheckoutResponse>> {
    const token = this.authService.getToken();
    return this.http.post<ApiResponse<MercadoPagoCheckoutResponse>>(
      `${this.paymentsUrl}/mercadopago/manual-order`,
      orderPayload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }

  redirectToCheckout(initPoint?: string, sandboxInitPoint?: string): void {
    const checkoutUrl = initPoint ?? sandboxInitPoint;
    if (!checkoutUrl) {
      console.error('No se recibió la URL de checkout de Mercado Pago.');
      return;
    }
    window.location.assign(checkoutUrl);
  }
}
